module.exports = __webpack_public_path__ + "static/media/full-screen-image-1.3b3892d1.jpg";